(function(app) {

    app.directive("uiSrefModalClick",
    [
        "figUiSrefModalService", function(figUiSrefModalService) {
            return {
                link: function(scope, element) {
                    element.bind("click",
                        function($event) {
                            figUiSrefModalService.$event = $event;
                        });
                }
            }
        }
    ]);

    app.provider("figUiSrefModalService",
    [
        function() {
            this.$get = [
                function() {
                    return {};
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line